// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Mr9b","overflowing":"ReadFullNote_overflowing__2EDqk"};